import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import '../../Styles/Header.css'
import Appbar from '../../Component/NavPannel/Appbar';
import OrdersLayout from '../../Component/Layouts/OrdersLayout';


const mdTheme = createTheme();

function Orders() {

  return (
    <ThemeProvider theme={mdTheme}>
       <Box sx={{ display: "flex", height: "100vh" }}>
        <CssBaseline />
        <Appbar mainpage="Home" subpage="Orders" />
        <OrdersLayout />
      </Box>
    </ThemeProvider>
  );
}

export default function Order() {
  return <Orders />
}